import React, { createContext, useState, useCallback, useContext } from 'react';

const SidePanelContext = createContext({});

const OneOnOneSidePanelContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openSidePanel = useCallback(() => setOpen(true), [setOpen]);
  const closeSidePanel = useCallback(() => setOpen(false), [setOpen]);

  return (
    <SidePanelContext.Provider value={{ isOpen: open, openSidePanel, closeSidePanel }}>
      {children}
    </SidePanelContext.Provider>
  );
};

export const useOneOnOneSidePanel = () => useContext(SidePanelContext);

export default OneOnOneSidePanelContextProvider;
